module.exports = __webpack_public_path__ + "static/media/market_primary.022d77c9.svg";